"use strict";

var _slicedToArray = require("/Users/Bas/repos/projects/catafolk/website/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchEngine = exports.default = void 0;

var _citeproc = _interopRequireDefault(require("citeproc"));

var _styles = require("./styles");

var _locales = require("./locales");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var proxied = Symbol.for('proxied');

var getWrapperProxy = function getWrapperProxy(original) {
  var proxy = function proxy(state, entry) {
    if (state.sys.wrapBibliographyEntry) {
      var _state$sys$wrapBiblio = state.sys.wrapBibliographyEntry(this.system_id),
          _state$sys$wrapBiblio2 = _slicedToArray(_state$sys$wrapBiblio, 2),
          prefix = _state$sys$wrapBiblio2[0],
          postfix = _state$sys$wrapBiblio2[1];

      entry = [prefix, entry, postfix].join('');
    }

    return original.call(this, state, entry);
  };

  proxy[proxied] = true;
  return proxy;
};

for (var format in _citeproc.default.Output.Formats) {
  var original = _citeproc.default.Output.Formats[format]['@bibliography/entry'];

  if (!original || original[proxied]) {
    continue;
  }

  _citeproc.default.Output.Formats[format]['@bibliography/entry'] = getWrapperProxy(original);
}

var engines = {};

var fetchEngine = function fetchEngine(style, lang, template, retrieveItem, retrieveLocale) {
  var engineHash = "".concat(style, "|").concat(lang);
  var engine;

  if (engines[engineHash] instanceof _citeproc.default.Engine) {
    engine = engines[engineHash];
    engine.sys.retrieveItem = retrieveItem;
  } else {
    engine = engines[engineHash] = new _citeproc.default.Engine({
      retrieveLocale: retrieveLocale,
      retrieveItem: retrieveItem
    }, template, lang, true);
  }

  return engine;
};

exports.fetchEngine = fetchEngine;

var prepareEngine = function prepareEngine(data, templateName, language, format) {
  var items = data.reduce(function (store, entry) {
    store[entry.id] = entry;
    return store;
  }, {});

  var template = _styles.templates.get(_styles.templates.has(templateName) ? templateName : 'apa');

  language = _locales.locales.has(language) ? language : 'en-US';
  var engine = fetchEngine(templateName, language, template, function (key) {
    return items[key];
  }, _locales.locales.get.bind(_locales.locales));
  engine.setOutputFormat(format);
  return engine;
};

var _default = prepareEngine;
exports.default = _default;